import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import type { TravelItinerary } from '@/lib/types';

const ME_API = '/api/v1/me';

export function useMyTravel() {
  return useQuery<TravelItinerary[]>({
    queryKey: ['my-travel'],
    queryFn: async () => {
      const response = await apiClient.get<TravelItinerary[]>(`${ME_API}/travel/`);
      return response.data;
    },
  });
}

export function useMyTravelItinerary(id: number) {
  return useQuery<TravelItinerary>({
    queryKey: ['my-travel', 'detail', id],
    queryFn: async () => {
      const response = await apiClient.get<TravelItinerary>(`${ME_API}/travel/${id}/`);
      return response.data;
    },
    enabled: id > 0,
  });
}

export function useConfirmMyTravel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number): Promise<{ status: string; acknowledged_at: string }> => {
      const response = await apiClient.post<{ status: string; acknowledged_at: string }>(
        `${ME_API}/travel/${id}/confirm/`
      );
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-travel'] });
      qc.invalidateQueries({ queryKey: ['my-dashboard'] });
      qc.invalidateQueries({ queryKey: ['travel-itineraries'] });
      qc.invalidateQueries({ queryKey: ['crew-assignments'] });
    },
  });
}
